import { render, staticRenderFns } from "./ShiftAtomFact.vue?vue&type=template&id=4116c218&"
import script from "./ShiftAtomFact.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomFact.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftAtomFact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports